var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 50,
    fill: "#D1FAE5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.9999 62L55.7143 50M44.2857 50L31.0001 62M30 40L46.3298 51.4309C47.6522 52.3565 48.3134 52.8193 49.0325 52.9986C49.6678 53.157 50.3322 53.157 50.9675 52.9986C51.6866 52.8193 52.3478 52.3565 53.6702 51.4309L70 40M39.6 66H60.4C63.7603 66 65.4405 66 66.7239 65.346C67.8529 64.7708 68.7708 63.8529 69.346 62.7239C70 61.4405 70 59.7603 70 56.4V43.6C70 40.2397 70 38.5595 69.346 37.2761C68.7708 36.1471 67.8529 35.2292 66.7239 34.654C65.4405 34 63.7603 34 60.4 34H39.6C36.2397 34 34.5595 34 33.2761 34.654C32.1471 35.2292 31.2292 36.1471 30.654 37.2761C30 38.5595 30 40.2397 30 43.6V56.4C30 59.7603 30 61.4405 30.654 62.7239C31.2292 63.8529 32.1471 64.7708 33.2761 65.346C34.5595 66 36.2397 66 39.6 66Z",
    stroke: "#047857",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.6006826fd71b7fe7a3f256e25aef40a1.svg";
export { ForwardRef as ReactComponent };